// src/components/ConnectionWarning.js
import React from 'react';
import { AlertCircle } from 'lucide-react';

const ConnectionWarning = ({ onRetryConnection }) => {
  return (
    <div className="connection-warning">
      <AlertCircle size={20} />
      <div className="warning-content">
        <span className="warning-title">Please install Brimind VIBE to enable enhanced coding features</span>
        <div className="warning-actions">
          <a 
            href="https://cloud.brinis.pro/storage/AI/Brimind-VIBE.zip" 
            className="download-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Brimind VIBE
          </a>
          <button onClick={onRetryConnection}>Retry Connection</button>
        </div>
        <div className="connection-help">
          <div className="install-instructions">
            <strong>Installation Instructions:</strong>
            <ul>
              <li><strong>Windows:</strong> Extract the ZIP file and double-click Vibe-Brimind-win.exe</li>
              <li><strong>Mac:</strong> Extract the ZIP file and run as admin using: <code>sudo ./Vibe-Brimind-macos</code></li>
              <li>Launch the application and it will enable advanced features automatically</li>
            </ul>
          </div>
          <div className="troubleshooting">
            <strong>Troubleshooting:</strong>
            <ul>
              <li>Make sure Brimind VIBE is running in the background</li>
              <li>Check if your firewall is blocking the application</li>
              <li>Try restarting the Brimind VIBE application</li>
              <li>Ensure you have administrator privileges when running the tool</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionWarning;